export default {
  rewardName: 'award miles',
  extraRewardsName: 'Extra miles',
  earnType: 'miles',
  shortProgramName: 'eShopping',
  instoreLabel: 'in-store',
};
